export default __webpack_public_path__ + "static/media/optimism-on-gnosis-chain.4d88f2de.png";